import get from 'lodash/get';
import { UserType } from 'api/models';
import { useCurrentUserProfile } from 'data/current-user-profile/hooks';
import { useUser } from 'hooks/use-user';

export const useUserType = (): UserType => {
  const { data } = useCurrentUserProfile(); // TODO:: @asim check whether we can use useUser() instead of this hook.

  return get(data, ['user', 'userType'], UserType.External);
};

export const useIsNativeUser = (): boolean => {
  const {
    user: { userType },
  } = useUser();

  return userType === UserType.Native;
};
export const useIsExternalUser = (): boolean => {
  const {
    user: { userType },
  } = useUser();

  return userType === UserType.External;
};
